import React from "react"

export interface CheckBoxProps {
    label?: string
    onChange?: (checked: boolean) => void
    checked?: boolean
}

interface CheckBoxState {
    checked: boolean
}

export class CheckBox extends React.Component<CheckBoxProps, CheckBoxState> {
    constructor(props: CheckBoxProps) {
        super(props)

        this.state = {
            checked: this.props.checked ? this.props.checked : false,
        }
    }

    onChange = (event: any) => {
        this.setState({ checked: event.target.checked })
        if (this.props.onChange) {
            this.props.onChange.call(this, event.target.checked)
        }
    }

    render() {
        if (!this.props.label) {
            return this.renderInput()
        }
        let lbl = ""
        if (this.props.label.includes("/")) {
            const labels = this.props.label.split("/")
            if (labels.length === 2) {
                lbl = this.state.checked ? labels[0] : labels[1]
            }
        }

        return (
            <div className="input-group">
                {this.renderInput()}
                {lbl}
            </div>
        )
    }

    private renderInput() {
        return <input type="checkbox" onChange={this.onChange} checked={this.props.checked} />
    }
}
